import { useEffect, useState } from "react";
import ArrowLeft from "../assets/img/arrow-left.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import FileUpload from "../components/FileUpload";
import CheckboxLabel from "../components/CheckboxLabel";
import Button from "../components/Button";
import Adder from "../components/AcreditacionesNoVerificados/Adder";
import PersonaAgregada from "../components/AcreditacionesNoVerificados/PersonaAgregada";
import Disclaimer from "../components/Disclaimer";
import Alerta from "../assets/img/alerta.svg";
import AcreditacionesCard from "../components/AcreditacionesVerificados/AcreditacionesCard";
import { usePost } from "../hooks";
import { fireGenericErrorModal, firePostSuccessModal } from "../utils/swals";
import { SignOut } from "../utils/auth";
import { getBase64 } from "../utils/files";

const AcreditacionesNoVerificado = () => {
  const [addedPeriodistas, setAddedPeriodistas] = useState([]);
  const [selectedPeriodistas, setSelectedPeriodistas] = useState([]);
  const [checkboxes, setCheckboxes] = useState([false, false, false]);
  const [file, setFile] = useState();
  const [comentarios, setComentarios] = useState(null);
  const [medioEsPartidario, setMedioEsPartidario] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { isLoading, postJson } = usePost();
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [id]);


  const handleCheckboxValues = (index) => {
    const newValues = [...checkboxes];
    newValues[index] = !newValues[index];
    setCheckboxes(newValues);
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const base64file = await getBase64(file);

      const body = {
        hojaMembretada: base64file,
        idEvento: id,
        comentarios: comentarios,
        periodistas: selectedPeriodistas,
        medioEsPartidario: medioEsPartidario === true,
      };

      const result = await postJson("/crear-solicitud-n", body);

      if (result.status === "KO") {
        fireGenericErrorModal();
      } else {
        firePostSuccessModal(
          () => {
            SignOut();
            navigate("/");
          },
          result.solicitudId,
          false
        );
      }
    } catch (error) {
      fireGenericErrorModal(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-gray">
      <div className="general-container">
        <Link to={"/"} className="volver">
          <img src={ArrowLeft} alt="" />
          <h6>Volver a Próximos eventos</h6>
        </Link>
        <div className="acreditaciones-box nv">
          <h1>
            Acreditaciones:{window.innerWidth < 768 ? <br /> : ""} ¿a quién vas
            a sumar?
            <h4 className="abn bajada mt-3">
              Ingresá los datos de las personas que deseas acreditar y no
              olvides chequear a aquellos que quieres que formen parte del
              evento.
            </h4>
          </h1>
          {addedPeriodistas.length > 5 ? (
            <Disclaimer
              pathIcono={Alerta}
              title={"Atención"}
              subtitle={
                "Alcanzaste el máximo permitido de periodistas a acreditar "
              }
              variant={"warning"}
              isVisible={addedPeriodistas.length > 5}
            />
          ) : (
            <Adder
              setAddedPeriodistas={setAddedPeriodistas}
              setSelectedPeriodistas={setSelectedPeriodistas}
            />
          )}

          <div className="personas-agregadas">
            {addedPeriodistas.map((per, i) => {
              if (window.innerWidth > 768) {
                return (
                  <PersonaAgregada
                    periodista={per}
                    key={i}
                    setSelected={setSelectedPeriodistas}
                    selectedPeriodistas={selectedPeriodistas}
                  />
                );
              } else {
                return (
                  <AcreditacionesCard
                    periodista={per}
                    selectedPeriodistas={selectedPeriodistas}
                    setSelectedPeriodistas={setSelectedPeriodistas}
                  />
                );
              }
            })}
          </div>

          <div className="datos">
            <h4>Datos del medio</h4>
            <h6>Adjuntá la hoja membretada para acreditar al medio</h6>
            <FileUpload name={"file"} file={file} setFile={setFile} />
          </div>
          <div className="datos">
            <h6>¿Es un medio partidario?</h6>
            <div style={{ display: "flex", gap: "16px", marginTop: "8px" }}>
              <Button
                variant={medioEsPartidario === true ? "login-btn enabled" : "outline-btn"}
                style={{ padding: "8px 32px", border: medioEsPartidario === true ? "2px solid transparent" : undefined }}
                onClick={() => setMedioEsPartidario(true)}
              >
                SI
              </Button>
              <Button
                variant={medioEsPartidario === false ? "login-btn enabled" : "outline-btn"}
                style={{ padding: "8px 32px", border: medioEsPartidario === false ? "2px solid transparent" : undefined }}
                onClick={() => setMedioEsPartidario(false)}
              >
                NO
              </Button>
            </div>
          </div>
          <div className="comentarios">
            <h6>Podés dejar tus comentarios aquí</h6>
            <input
              type="text"
              placeholder="Comentarios..."
              className="comment-input"
              onChange={(e) => setComentarios(e.target.value)}
            />
          </div>
          <CheckboxLabel
            label={
              "Declaro que los datos consignados en este formulario son correctos y completos; he confeccionado esta declaración sin falsear ni omitir dato alguno, siendo fiel expresión de la verdad."
            }
            handleCheckboxChange={handleCheckboxValues}
            index={0}
          />
          <CheckboxLabel
            label={
              "Tomo conocimiento y acepto la <a href='/pdf/53-normativa2020.pdf' target='_blank'><span class='fw600 text-underline'>Normativa de Prensa</span> del Club atlético River Plate."
            }
            handleCheckboxChange={handleCheckboxValues}
            index={1}
          />
          <CheckboxLabel
            label={
              "<a>Leí y estoy de acuerdo con el <a href='https://www.cariverplate.com.ar/acreditaciones/anexo-2024' target='_blank'><span class='fw600 text-underline'>Anexo 2024</span></a>"
            }
            handleCheckboxChange={handleCheckboxValues}
            index={2}
          />
          <Button
            variant={`login-btn ${
              file &&
              selectedPeriodistas.length &&
              checkboxes.every(Boolean) &&
              medioEsPartidario !== null &&
              !isLoading &&
              !isSubmitting
                ? "enabled"
                : ""
            }`}
            isDisabled={
              !(
                file &&
                selectedPeriodistas.length &&
                checkboxes.every(Boolean) &&
                medioEsPartidario !== null
              ) || isLoading || isSubmitting
            }
            onClick={handleSubmit}
          >
            Confirmar acreditación
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AcreditacionesNoVerificado;
